import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ACTIVITIES = [
  {
    title: "Lough Ree by boat",
    body: "Lough Ree is one of Ireland's great inland lakes — 30 km long and dotted with islands, including the historic Inchagoill Island with its early Christian monastery. Boat hire is available from Athlone marina, or ask us about local operators for guided trips.",
  },
  {
    title: "Glasson Golf Club",
    body: "One of Ireland's most scenic golf courses, Glasson Golf & Country Club sits on the shores of Lough Ree just 2 km from the marina. The 18-hole parkland course is open to visitors and the clubhouse overlooks the water.",
  },
  {
    title: "Athlone Castle",
    body: "Built in 1210, Athlone Castle is one of the best-preserved Norman castles in Ireland. The visitor centre tells the story of the Siege of Athlone and the town's role in Irish history. It's an easy 20-minute drive from the marina.",
  },
  {
    title: "Sean's Bar, Athlone",
    body: "Established in 900 AD, Sean's Bar is officially the world's oldest pub according to Guinness World Records. Sitting on the banks of the River Shannon in Athlone, it's a must for a traditional Irish evening. Live music at weekends.",
  },
  {
    title: "Walking and cycling",
    body: "The lanes around Glasson and Killinure are quiet and beautiful — ideal for cycling or a morning walk. The Westmeath Greenway runs nearby for longer off-road routes. Bikes can be hired in Athlone.",
  },
  {
    title: "Pike fishing on Lough Ree",
    body: "Lough Ree is internationally known for its pike fishing, with large specimens regularly caught. The lake also holds bream, roach and perch. Local guides and boat hire are available through Athlone Angling Club.",
  },
  {
    title: "The Chalets Restaurant",
    body: "Just 1 km from the marina, The Chalets is a local favourite for dinner. Relaxed and unpretentious, it serves good food in a friendly setting — no need to drive far for a great meal.",
  },
  {
    title: "Glasson Lakehouse Hotel",
    body: "1.5 km along the lakeshore, Glasson Lakehouse is worth visiting for its spa, Sunday lunch or an evening cocktail with views over Lough Ree. Non-guests are welcome for dining and spa treatments.",
  },
];

export default function ThingsToDo() {
  return (
    <div className="bg-[#FAFAF8] text-[#1C1C1A] min-h-screen">
      <Helmet>
        <title>Things to Do on Lough Ree &amp; Athlone | Aquastays</title>
        <meta name="description" content="Boat trips, Glasson golf, Sean's Bar, Athlone Castle, walks and pike fishing — our local guide for a weekend on Lough Ree, Co. Westmeath." />
        <link rel="canonical" href="https://aquastays.com/lough-ree-things-to-do" />
      </Helmet>

      <Header solid />

      <main className="max-w-[860px] mx-auto px-6 sm:px-10 py-20 sm:py-28">
        <p className="eyebrow text-[#6B6B65] mb-4">Local guide</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-[#1C1C1A] tracking-tight leading-tight mb-6">
          Things to do on Lough Ree &amp; Athlone.
        </h1>
        <p className="text-sm text-[#6B6B65] font-light leading-relaxed mb-14 max-w-xl">
          Inner Lakes Marina sits at the heart of one of Ireland's most underrated weekend-away destinations. The lough, the castle, the oldest pub in the world — there's more here than most people expect. This is our honest local guide.
        </p>

        <div className="space-y-10">
          {ACTIVITIES.map((a) => (
            <div key={a.title} className="border-b border-[#1C1C1A]/8 pb-10">
              <h2 className="font-medium text-[#1C1C1A] text-base mb-2">{a.title}</h2>
              <p className="text-sm text-[#6B6B65] font-light leading-relaxed">{a.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-10 border-t border-[#1C1C1A]/8 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <p className="text-sm text-[#6B6B65] font-light">Base yourself on the water.</p>
          <div className="flex gap-4 flex-wrap">
            <Link to="/boats/aquastays-drift" className="text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#1C1C1A] hover:text-[#E8970A] transition-colors">
              View the houseboat →
            </Link>
            <a href="https://aquastays.guestybookings.com/en/properties/69dff123051f000012a8ddb6" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-6 py-2.5 rounded-full bg-[#E8970A] hover:bg-[#D08500] text-white font-semibold text-sm transition-colors">
              Check availability
            </a>
          </div>
        </div>

        <p className="mt-10 text-xs text-[#6B6B65]">
          Also see <Link to="/getting-here" className="underline underline-offset-2 hover:text-[#1C1C1A]">how to get here</Link> and our <Link to="/faq" className="underline underline-offset-2 hover:text-[#1C1C1A]">FAQs</Link>.
        </p>
      </main>

      <Footer />
    </div>
  );
}
